module.exports = __webpack_public_path__ + "img/loginNew1.2b137205.png";